<vm-contact-us
  [routerLinkText]="routerLinkText"
  [routerLinkHref]="routerLinkHref"
  [enableBackLink]="enableBackLink"
  [confirmationInput]="confirmationInput"
  [workflowConstants]="workflowConstants"
  (next)="onNext($event)"
  (back)="onBack($event)"
  (openSecondaryModal)="onOpenSecondaryModal()">
</vm-contact-us>
